import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import { ImageZoomDialog } from './image-zoom-dialog.component';

interface IZoomableImageProps {
  src?: string;
  alt: string;
  minHeight?: number;
  maxHeight?: number;
  mb?: number;
}

// Click-to-enlarge preview image; on a load error the whole preview (and its zoom dialog) drops out.
// Shared by both FormatTemplate modals so the preview/zoom behavior has a single source of truth.
export const ZoomableImage: React.FC<IZoomableImageProps> = ({
  src,
  alt,
  minHeight = 200,
  maxHeight = 360,
  mb = 2,
}) => {
  // Reset the failed flag whenever the source URL changes.
  const [errored, setErrored] = useState(false);
  useEffect(() => setErrored(false), [src]);

  const [zoomOpen, setZoomOpen] = useState(false);

  const url = errored ? undefined : src;
  if (!url) return null;

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={mb}
        style={{ minHeight, background: '#f5f5f5', borderRadius: 4 }}
      >
        <img
          src={url}
          alt={alt}
          title="Click to enlarge"
          role="button"
          tabIndex={0}
          onClick={() => setZoomOpen(true)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setZoomOpen(true); }
          }}
          onError={() => {
            console.warn('ZoomableImage: preview image failed to load:', url);
            setErrored(true);
          }}
          style={{ maxWidth: '100%', maxHeight, objectFit: 'contain', borderRadius: 4, cursor: 'zoom-in' }}
        />
      </Box>
      <ImageZoomDialog open={zoomOpen} onClose={() => setZoomOpen(false)} src={url} alt={alt} />
    </>
  );
};
